
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/workshops/[module]/[section]/[lesson]/embed",
      function () {
        return require("private-next-pages/workshops/[module]/[section]/[lesson]/embed.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/workshops/[module]/[section]/[lesson]/embed"])
      });
    }
  